<template>
  <div class="cell grid-y align-justify padding-top-s padding-bottom-s padding-xs wrapper">
    <div class="card-text cell">
      <div class="offerHeading margin-bottom-xxs">
        <strong class="offerHeadingText eyebrow">
          {{ offerHeading }}
        </strong>
      </div>
      <div
        ref="offerNameRef"
        class="offer-name large margin-bottom-s truncated"
      >
        <span :class="OFFERS_CAROUSEL.CLASS_OFFER_NAME">
          {{ offerName }}
        </span>
      </div>

      <div
        ref="offerDescRef"
        class="offer-desc small margin-bottom-s truncated"
      >
        {{ offerDesc }}
      </div>
    </div>
    <div>
      <div class="cell align-justify margin-bottom-s">
        <div class="card-text">
          <div
            v-if="offerExpDate"
            class="offer-expiry small carousel-bottom-space"
          >
            <strong>{{ OFFERS_CAROUSEL.PROMO_ENDS }}: {{ offerExpDate }}</strong>
          </div>
        </div>
        <div
          v-if="offerCode?.length"
          class="promo-container-main small carousel-bottom-space"
        >
          <div class="promo-flex-1">
            <span class="promo-lable">{{ OFFERS_CAROUSEL.PROMO_CODE }}: </span>
            <span class="promo-txt margin-right-xxs">
              {{ offerCode }}
            </span>
          </div>
          <div
            class="promo-flex-2 copy-promo align-right"
            @click.prevent="copyPromo(offerCode, index)"
          >
            <span
              class="ui-icon margin-right-xxs custom-copy-icon"
              :class="brand === 'mcom' ? 'copy-dark-small' : 'copy'"
            ></span>
            <span
              v-if="isPromoCopied"
              class="promo-copy-txt"
              >{{ OFFERS_CAROUSEL.COPIED }}</span
            >
            <span
              v-else
              class="promo-copy-txt"
              >{{ OFFERS_CAROUSEL.COPY }}</span
            >
          </div>
        </div>
        <div
          v-else
          class="no-promocode small carousel-bottom-space"
        >
          {{ OFFERS_CAROUSEL.NO_OFFER_CODE }}
        </div>
        <div class="cell grid-x align-justify align-middle">
          <div class="promo-links-exclusion">
            <a
              v-if="exclusionContent?.length"
              class="link-sm"
              @click.stop="$emit('exclusionModalHandler', offer)"
            >
              <span> {{ OFFERS_CAROUSEL.LINK_INFO_EXCLUSION }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="cell align-justify">
        <div class="shop-now card-text">
          <p class="align-justify">
            <button
              class="secondary button button-small expanded"
              @click.prevent="shopNowButtonHandler(index)"
            >
              {{ OFFERS_CAROUSEL.SHOP_NOW }}
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs, ref } from 'vue';
import { OFFERS_CAROUSEL, brand } from '../../config';
import { eventAnalyticsFunctionTag } from '../../utils/eventsTagUtil';

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});
const { offer, index } = toRefs(props);
const { offerName, offerDesc, offerExpDate, offerCode, legalDisclaimer: exclusionContent, offerHeading } = offer.value;
const isPromoCopied = ref(false);

/* eslint-disable */
const copyPromo = (promo, itemIndex) => {
  // itemIndex;for Analytics tracking
  navigator.clipboard.writeText(promo).then(() => {
    isPromoCopied.value = true;
    setTimeout(() => {
      isPromoCopied.value = false;
    }, 300);
  });
};

/* eslint-disable */
const shopNowButtonHandler = (itemIndex) => {
  // itemIndex for Analytics tracking
  eventAnalyticsFunctionTag('OFFERS_CAROUSEL', 'shopNow', itemIndex);
  window.open(window.location.origin, '_blank');
};
</script>





<style lang="scss" scoped>
@import '~settingSCSS';
@import '@csgIcons/new/_copy-dark-small.scss';

$card-height: rem-calc(286);
$wrapper-min-height: rem-calc(397px);

.wrapper {
  align-content: start;
  cursor: pointer;
  width: auto;
  overflow: hidden;
  border: $gray-3-border;
  min-height: $wrapper-min-height;

  &.expanded {
    height: auto;
    min-height: $card-height;
    position: relative;
  }
}

.offerHeading {
  overflow: hidden;
  &.truncated {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
}

.offer-name {
  overflow: hidden;
  &.truncated {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }
}

.offer-desc {
  overflow: hidden;
  &.truncated {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
}

.carousel-bottom-space {
  margin-bottom: rem-calc(4);
}

.promo-container-main {
  display: flex;
  align-items: center;
  vertical-align: middle;
  .promo-flex-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
  }
  .promo-flex-2 {
    white-space: nowrap;
  }
  .copy-promo {
    white-space: nowrap;
  }
  .copy-promo .ui-icon.copy {
    vertical-align: middle;
    transform: scale(0.9);
  }
}


$offer-category-height: rem-calc(18px);
$offer-name-min-height: rem-calc(86px);
$offer-name-height-mew: rem-calc(82px);
$offer-desc-height: rem-calc(50px);
$promo-exclusionlink-height: rem-calc(18px);
$promo-container-main-height: rem-calc(20px);

.offerHeading {
  height: $offer-category-height;
}
.offerHeading .offerHeadingText {
  color: $loyalty-1-color;
}
.offer-name {
  min-height: $offer-name-min-height;
  @include breakpoint(large down) {
    height: $offer-name-height-mew;
  }
}
.offer-desc {
  height: $offer-desc-height;
}
.promo-links-exclusion {
  height: $promo-exclusionlink-height;
}
.promo-container-main,
.no-promocode {
  height: $promo-container-main-height;
}
</style>